/* eslint-disable prettier/prettier */
export const section = [
  'w-full bg-[linear-gradient(0deg,rgba(80,37,235,0.2),rgba(80,37,235,0.2)),url("/images/medicontents/landing/hero-bg.png")] bg-cover bg-no-repeat'
].join(' ');

export const Wrapper = [
  'flex flex-col-reverse justify-center w-full max-w-[23.438rem] md:max-w-[90rem] mx-auto bg-lightgray bg-[position:50%]',
  'gap-[1.75rem] pt-[2.75rem] pb-[3.375rem]',
  'md:flex-row md:justify-between md:gap-4 md:py-[7.56rem] md:pl-[4.869rem]'
].join(' ');

export const contentWrapper = [
  'flex flex-col items-center md:min-w-[21.875rem]',
  'gap-6',
  'md:items-start md:gap-10 md:pt-[1rem] md:pb-[4.625rem]'
].join(' ');

export const copyWrapper = [
  'flex flex-col',
  'gap-2.5',
  'md:items-start md:gap-6'
].join(' ');

export const title = [
  'font-bold text-white',
  'text-center text-[1.75rem] leading-[135%]',
  'md:text-start md:text-[3rem]'
].join(' ');

export const description = [
  'text-white',
  'text-center text-[0.975rem] leading-[147%]',
  'md:text-start md:text-[1.251rem] md:leading-[135%] md:font-medium'
].join(' ');

export const button = [
  'flex w-fit items-center justify-center gap-2 rounded-md bg-[#03095C]',
  'px-8 py-4',
  'md:px-8 md:py-4'
].join(' ');

export const buttonText = [
  'text-white font-semibold',
  'text-[1.17rem] leading-[145%]',
  'md:text-[1.251rem] md:leading-[140%] md:font-bold'
].join(' ');

export const mobileArrow = ['w-[1.17rem] h-[1.17rem]', 'md:hidden'].join(' ');

export const imageWrapper = [
  'relative w-full',
  'h-[13.75rem]',
  'md:h-[26.127rem] md:w-[40.689rem]'
].join(' ');

export const mobileHeroImage = ['object-contain', 'md:hidden'].join(' ');

export const desktopHeroImage = [
  'object-contain',
  'hidden',
  'md:block'
].join(' ');
